import { Dot } from "lucide-react"
import { ColorConfig } from "./Chat"

type TypingIndicatorProps = {
  colorConfig?: ColorConfig
  label?: string
}

export function TypingIndicator({ colorConfig, label }: TypingIndicatorProps) {
  return (
    <div className="justify-left flex space-x-1">
      <div
        className="relative isolate overflow-hidden rounded-lg rounded-bl-none p-2 px-4 bg-muted"
        style={colorConfig?.assistant}
      >
        <span
          aria-hidden
          className="pointer-events-none absolute inset-0 -z-10"
          style={{
            background:
              "linear-gradient(90deg, transparent 25%, rgba(255,255,255,0.35) 50%, transparent 75%)",
            backgroundSize: "200% 100%",
            animation: "shine 2.6s ease-out infinite",
          }}
        />
        {label ? (
          <span
            key={label}
            className="relative z-10 text-sm animate-in fade-in duration-500 text-muted-foreground"
          >
            {label}
          </span>
        ) : (
          <div className="flex -space-x-2.5">
            <Dot className="h-5 w-5 animate-bounce-in-place delay-0 duration-300" />
            <Dot className="h-5 w-5 animate-bounce-in-place delay-150 duration-300" />
            <Dot className="h-5 w-5 animate-bounce-in-place delay-300 duration-300" />
          </div>
        )}
      </div>
    </div>
  )
}
